import type { CSSProperties } from "react";

type Segment = {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
  duration?: number;
  delay?: number;
};

const segments: Segment[] = [
  { x1: 4, y1: 16, x2: 22, y2: 28, duration: 18, delay: 0 },
  { x1: 22, y1: 28, x2: 38, y2: 18, duration: 15, delay: 2 },
  { x1: 38, y1: 18, x2: 58, y2: 30, duration: 16, delay: 1 },
  { x1: 58, y1: 30, x2: 78, y2: 20, duration: 17, delay: 3 },
  { x1: 78, y1: 20, x2: 94, y2: 34, duration: 19, delay: 2 },

  { x1: 10, y1: 52, x2: 28, y2: 64, duration: 16, delay: 4 },
  { x1: 28, y1: 64, x2: 46, y2: 54, duration: 14, delay: 1 },
  { x1: 46, y1: 54, x2: 66, y2: 66, duration: 18, delay: 5 },
  { x1: 66, y1: 66, x2: 88, y2: 58, duration: 15, delay: 2 },

  { x1: 18, y1: 10, x2: 22, y2: 28, duration: 20, delay: 6 },
  { x1: 38, y1: 18, x2: 40, y2: 42, duration: 17, delay: 3 },
  { x1: 58, y1: 30, x2: 54, y2: 54, duration: 16, delay: 2 },
  { x1: 78, y1: 20, x2: 80, y2: 46, duration: 18, delay: 4 },
  { x1: 28, y1: 64, x2: 26, y2: 88, duration: 21, delay: 7 },
  { x1: 66, y1: 66, x2: 70, y2: 90, duration: 19, delay: 5 },
];

export default function NetworkConnections() {
  return (
    <div className="marketing-network-bg" aria-hidden="true">
      <svg
        className="marketing-network-svg"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="networkStatic" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#1e3a8a" stopOpacity="0.15" />
            <stop offset="50%" stopColor="#334155" stopOpacity="0.08" />
            <stop offset="100%" stopColor="#0f172a" stopOpacity="0.05" />
          </linearGradient>

          <linearGradient id="networkComet" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#22d3ee" stopOpacity="0" />
            <stop offset="45%" stopColor="#22d3ee" stopOpacity="0.15" />
            <stop offset="70%" stopColor="#38bdf8" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#60a5fa" stopOpacity="0" />
          </linearGradient>
        </defs>

        {segments.map((segment, index) => (
          <g key={index}>
            {/* linha base da rede */}
            <line
              x1={segment.x1}
              y1={segment.y1}
              x2={segment.x2}
              y2={segment.y2}
              className="network-grid-line"
            />

            {/* “cometa” / fluxo passando na linha */}
            <line
              x1={segment.x1}
              y1={segment.y1}
              x2={segment.x2}
              y2={segment.y2}
              className="network-comet-line"
              style={
                {
                  ["--network-duration" as string]: `${segment.duration ?? 16}s`,
                  ["--network-delay" as string]: `${segment.delay ?? 0}s`,
                } as CSSProperties
              }
            />
          </g>
        ))}
      </svg>
    </div>
  );
}